// Rider gearlist — structured items on the public profile.
export const GEAR_CATEGORIES = [
  { key: 'bike',    label: 'Bike',    icon: '🏍️' },
  { key: 'helmet',  label: 'Helmet',  icon: '🪖' },
  { key: 'jacket',  label: 'Jacket',  icon: '🧥' },
  { key: 'gloves',  label: 'Gloves',  icon: '🧤' },
  { key: 'boots',   label: 'Boots',   icon: '🥾' },
  { key: 'comms',   label: 'Comms',   icon: '🎧' },
  { key: 'luggage', label: 'Luggage', icon: '🎒' },
  { key: 'other',   label: 'Other',   icon: '🔧' },
];

export const GEAR_CAT = Object.fromEntries(GEAR_CATEGORIES.map(c => [c.key, c]));
export const MAX_GEAR = 25;

// Outbound gear links carry the app's affiliate tag for supported retailers, so
// the app earns commission when a rider buys the exact gear someone runs.
// Inert until a tag is configured here.
const AFFILIATE = {
  amazon: '',   // Amazon Associates tag, e.g. 'roamr-20'
};

export function affiliatize(url) {
  if (!url) return url;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    if (/(^|\.)amazon\./.test(host) && AFFILIATE.amazon) {
      u.searchParams.set('tag', AFFILIATE.amazon);
    }
    return u.toString();
  } catch {
    return url;
  }
}

export function normalizeGearUrl(url) {
  const s = (url || '').trim();
  if (!s) return '';
  return /^https?:\/\//i.test(s) ? s : `https://${s}`;
}

// Strip empties + clamp before saving.
export function cleanGear(gear) {
  return (gear || [])
    .filter(g => g && (g.name || '').trim())
    .slice(0, MAX_GEAR)
    .map(g => ({
      category: GEAR_CAT[g.category] ? g.category : 'other',
      name: g.name.trim().slice(0, 80),
      brand: (g.brand || '').trim().slice(0, 60),
      url: normalizeGearUrl(g.url),
    }));
}
